import { markCallAsProcessing as apiMarkCallAsProcessing } from '@/api/calls'

export default {
  namespaced: true,
  actions: {
    async markCallAsProcessing(_, callId) {
      try {
        await apiMarkCallAsProcessing(callId)
      } catch (e) {
        console.error('markCallAsProcessing failed', e)
        throw e
      }
    }
  }
}
